import { tv, type VariantProps } from 'tailwind-variants';
export type MlCopySectionVariants = VariantProps<typeof mlCopySectionVariants>;

const mlCopySectionVariants = tv({
  base: '',
  slots: {},
  variants: {
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default mlCopySectionVariants;
